var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade-in-top-btn","mode":"out-in"}},[(_vm.isVisible)?_c('Button',{staticClass:"back-to-top",attrs:{"display":"icon"},on:{"click":_vm.toTop}},[_c('SVGicon-up-arrow'),_c('span',[_vm._v("Top")])],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }